/**
 * Os dois modos de CTA da landing.
 *
 *   FORMS — o que existia: os botões levam ao funil (`#plano` → `/assinar`),
 *           com etapas e planos na web.
 *   APP   — os botões levam DIRETO para a loja do aparelho: App Store no
 *           iPhone, Play Store no Android, e `/baixar` no desktop (onde não há
 *           loja do sistema para escolher sozinho).
 *
 * Quem manda é o documento `APP_CONFIG/LANDING_CTA` no Firestore, editável pelo
 * painel sem deploy — mesmo padrão de `APP_CONFIG/ADS`.
 *
 * O PADRÃO É `APP`, e isso vale para TODO caminho que não seja um modo
 * reconhecido: documento ausente, campo vazio, valor escrito errado, leitura
 * que falhou. A landing é a porta de entrada do produto — se o modo não puder
 * ser lido, ela tem de continuar vendendo algo, e a decisão de produto é que
 * esse algo é o download do app. Nunca uma tela com botão que não leva a nada.
 */

export const MODOS = { APP: 'APP', FORMS: 'FORMS' };

export const MODO_PADRAO = MODOS.APP;

/** O campo do documento. SCREAMING_SNAKE_CASE como o resto do `APP_CONFIG`. */
export const CAMPO = 'MODO';

export const CAMINHO = ['APP_CONFIG', 'LANDING_CTA'];

/**
 * Config crua do Firestore → modo válido.
 *
 * Tolerante de propósito: aceita minúscula e espaço em volta, porque quem
 * digita no painel não deve precisar acertar a caixa. Qualquer coisa que não
 * seja um dos dois modos cai no padrão.
 */
export function resolverModo(config) {
  const bruto = config && config[CAMPO];
  if (typeof bruto !== 'string') return MODO_PADRAO;
  const limpo = bruto.trim().toUpperCase();
  return limpo === MODOS.FORMS || limpo === MODOS.APP ? limpo : MODO_PADRAO;
}

/**
 * O que cada CTA da landing faz e diz, por modo.
 *
 * Devolve DESCRITOR, não JSX: assim o teste cobre a decisão (rótulo e destino)
 * sem montar componente, e a landing só desenha.
 *
 * `paraApp` é a única diferença de comportamento — quando true, o clique chama
 * `abrirApp()` em vez de navegar no site.
 */
export function ctaDaLanding(modo) {
  const efetivo = modo === MODOS.FORMS ? MODOS.FORMS : MODO_PADRAO;

  if (efetivo === MODOS.APP) {
    return {
      modo: MODOS.APP,
      paraApp: true,
      // O rótulo é o MESMO dos três botões: em modo app não há "ver o plano"
      // antes, então diferenciar o do cartão de preço só confundiria.
      rotulo: 'Começar agora',
      rotuloDoPlano: 'Começar agora',
      // O href é `/baixar`, NÃO a URL de uma loja: href fixo de loja mandaria
      // iPhone para a Play Store. A loja certa é resolvida no clique, por
      // `abrirApp()`.
      //
      // E não é `null` porque o href é o caminho que sobra quando o clique não
      // passa pelo JavaScript: foco de teclado, "abrir em nova aba", botão do
      // meio, JS que não carregou. `/baixar` mostra as duas lojas, então todos
      // esses caminhos chegam a algum lugar certo em vez de a nenhum.
      href: '/baixar',
      paraOnde: 'loja',
    };
  }

  return {
    modo: MODOS.FORMS,
    paraApp: false,
    rotulo: 'Começar agora',
    // Exatamente o rótulo de hoje, com a seta — o modo FORMS preserva a
    // landing como ela está.
    rotuloDoPlano: 'Começar agora →',
    href: '#plano',
    paraOnde: 'funil',
  };
}
